import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row,
  Input,
  FormText,
} from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";
import moment from "moment";
import NotificationSystem from "react-notification-system";

import { addLog, apiActions, modalActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
import SelectCreatableListComponent from "../utils/selectCreatableList";
import AddIcon from "react-icons/lib/md/save";
import CheckIcon from "react-icons/lib/md/info";

import { commonService } from "../../_services";
import PDMDataEntryRecord from "./pdm-entry";

const Currency = [
  { name: "Naira", id: 566 },
  { name: "Dollar", id: 840 },
];
class SearchPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      openModal: false,
      airlineName: "",
      currency: "",
      depName: "",
      desName: "",
      airlines: [],
      flights: [],
      AirlineId: "",
      searchAirlineId: "",
      filteredFlightNumbers: [],
      searchFlightNumber: "",
      FlightNumber: "",
      DepartureDate: new Date(),
      departureAirports: [],
      DepartureAirportId: "",
      destinationAirports: [],
      DestinationAirportId: "",
      selectedOption: "",
      IsLocal: false,
      PAXCount: "",
      TSCAmount: "",
      Matched: true,
      url: `${appConstants.PAS_URL}/api/postdeparturemanifest/insert`,
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        dismissible: true,
      },
      contentErrorText: false,
      pdm: [],
      currencies: [
        { value: 566, label: "Naira" },
        { value: 840, label: "Dollar" },
      ],
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  resetError() {
    this.props.dispatch(modalActions.clear());
  }

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };
  handleSubmit = (event) => {
    event.preventDefault();
    const { dispatch } = this.props;
    dispatch(addLog("Add PDM Record client"));

    const {
      pdm,
      selectedOption,
      TSCAmount,
      PAXCount,
      DepartureDate,
      searchAirlineId,
      searchFlightNumber,
      DepartureAirportId,
      DestinationAirportId,
    } = this.state;
    if (this.validateInput()) {
      pdm.push({
        AirlineId: searchAirlineId,
        DepartureDate: moment(DepartureDate).format("YYYY-MM-DD"),
        FlightNumber: searchFlightNumber,
        DepartureAirportId: DepartureAirportId,
        DestinationAirportId: DestinationAirportId,
        CreatedBy: appHelpers.getActiveUser().userName,
        PassengersCount: Number(PAXCount),
        TSCAmount: TSCAmount,
        CurrencyId: Number(selectedOption.value),
      });
      this.setState({ pdm }, this.resetForm);
    }
  };

  initializeSave = () => {
    this.setState({ openModal: true });
  };

  handleSave = () => {
    const { pdm } = this.state;
    const { dispatch } = this.props;
    this.setState({ openModal: false });
    dispatch(apiActions.startRequest());

    commonService.addBulkPdm(pdm).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        dispatch(apiActions.endRequest());
        this.notify(
          "Records created successfully",
          appConstants.NOTIFY_SUCCESS
        );
        this.restartForm();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        let responsePDMData = res.response.createResponsePdms;
        console.log(responsePDMData, "azy");

        let newPDMData = this.convertAPIresponseToUIFormat(responsePDMData);
        this.setState({ pdm: newPDMData });
        this.notify(
          `${res.response.FailedCount} Records Failed. ${res.response.SucessfullCount} Records Successful. `,
          appConstants.NOTIFY_ERROR
        );
        dispatch(apiActions.endRequest());
      }
    });
  };

  convertAPIresponseToUIFormat = (responsePDM) => {
    let formattedResponse =
      responsePDM &&
      responsePDM.map(({ ErrorMessage, Status, postDepartureManifest }) => {
        return { ErrorMessage, Status, ...postDepartureManifest };
      });

    console.log(formattedResponse, "azy");
    return formattedResponse;
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    const {
      searchFlightNumber,
      searchAirlineId,
      DepartureAirportId,
      DestinationAirportId,
      PAXCount,
      TSCAmount,
      selectedOption,
    } = this.state;
    // if( DepartureDate === ''){
    //     _errs_['DepartureDate'] = 'Please select flight date';
    //     formValid = false;
    // }
    if (TSCAmount.length > 0 && selectedOption === "") {
      _errs_["Currency"] = "Please select Currency";
      formValid = false;
    }
    if (searchAirlineId === "") {
      _errs_["searchAirlineId"] = "Please select airline";
      formValid = false;
    }
    if (searchFlightNumber === "") {
      _errs_["searchFlightNumber"] = "Please enter flight number";
      formValid = false;
    }
    if (DepartureAirportId === "") {
      _errs_["DepartureAirportId"] = "Please select departure airport";
      formValid = false;
    }
    if (DestinationAirportId === "") {
      _errs_["DestinationAirportId"] = "Please select destination airport";
      formValid = false;
    }
    if (PAXCount === "") {
      _errs_["PAXCount"] = "Please enter Pax Count";
      formValid = false;
    }
    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  handleAirlineChange = (target) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["searchAirlineId"] = false;
    if (!(target === null && this.state.searchAirlineId === "")) {
      //Get All flights for airline
      let airlineId = target ? target.Id : "";
      this.setState({
        componentErrorMessages: errorMessages,
        searchAirlineId: airlineId,
        filteredFlightNumbers: [],
        searchFlightNumber: "",
      });

      //Get flight Numbers for airline
      this.fetchAirlineFlightNumbers(airlineId);
    }
  };
  handleFlightChange = (target) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["searchFlightNumber"] = false;
    ;
    if (!(target === null && this.state.searchFlightNumber === "")) {
      let searchFlightNumber = "";
      let { DepartureAirportId, DestinationAirportId } = this.state;
      if (target) {
        searchFlightNumber = target.FlightNumber;
        DestinationAirportId = target.DestinationAirportId;
        DepartureAirportId = target.DepartureAirportId;
      }
      this.setState({
        componentErrorMessages: errorMessages,
        searchFlightNumber,
        DepartureAirportId,
        DestinationAirportId,
      });
    }

  };
  fetchAirlineFlightNumbers = (airlineId) => {
    this.setState({ contentError: false, filteredFlightNumbers: [] });
    const { dispatch } = this.props;
    dispatch(apiActions.startRequest());
    commonService.getAirlinesFlightNumbers(airlineId).then((res) => {
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({ filteredFlightNumbers: response.Results });
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        this.notify(response, appConstants.NOTIFY_ERROR);
      }
    });
  };
  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  paxChange(event) {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["PAXCount"] = false;
    this.setState({
      componentErrorMessages: errorMessages,
      PAXCount: event.target.value,
    });
  }

  tscAmountChange(event) {
    this.setState({ TSCAmount: event.target.value });
  }
  handleCurrencyChange = (selectedOption) => {
    let errorMessages = this.state.componentErrorMessages;
    errorMessages["searchFlightNumber"] = false;
    this.setState({
      selectedOption: selectedOption,
      componentErrorMessages: errorMessages,
    });
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      selectedOption: "",
      failedManifestDelete: false,
      successfulManifestDelete: false,
      searchFlightNumber: "",
      DepartureAirportId: "",
      IsLocal: false,
      DestinationAirportId: "",
      PAXCount: "",
      TSCAmount: "",
      CurrencyId: "",
    });
  }
  restartForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      selectedOption: "",
      failedManifestDelete: false,
      successfulManifestDelete: false,
      searchFlightNumber: "",
      DepartureAirportId: "",
      IsLocal: false,
      DestinationAirportId: "",
      PAXCount: "",
      TSCAmount: "",
      CurrencyId: "",
      pdm: [],
      searchAirlineId: "",
      filteredFlightNumbers: [],
    });
  }
  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }
  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetModal();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };
  toggleModal = () => {
    let { openModal } = this.state;
    this.setState({ openModal: !openModal });
  };
  getAirlineName() {
    const { searchAirlineId } = this.state;
    const { airlines } = this.props;
    let getAirline = airlines.find((airline) => airline.Id === searchAirlineId);
    let airlineName = getAirline.Name;
    this.setState({ airlineName });
  }
  getDesAirport() {
    const { DestinationAirportId } = this.state;
    const { destinationAirports } = this.props;
    let getDes = destinationAirports.find(
      (destination) => destination.Id === DestinationAirportId
    );
    let desName = getDes.Name;
    this.setState({ desName });
  }
  getDepAirport() {
    const { DepartureAirportId } = this.state;
    const { departureAirports } = this.props;
    let getDep = departureAirports.find(
      (departure) => departure.Id === DepartureAirportId
    );
    let depName = getDep.Name;
    this.setState({ depName });
  }
  findAirport = (DepartureAirportId) => {
    const { departureAirports } = this.props;
    let airport = departureAirports.find(
      (departure) => departure.Id === DepartureAirportId
    );
    return airport ? airport.Name : "Unknown Airport";
  };
  findAirline = (AirlineId) => {
    const { airlines } = this.props;
    let airline = airlines.find((airline) => airline.Id === AirlineId);
    return airline ? airline.Name : "Unknown Airline";
  };
  findCurrency = (currencyValue) => {
    const { currencies } = this.state;
    const currency = currencies.find((item) => item.value === currencyValue);
    return currency ? currency.label : "";
  };
  removeDataRecord = (index) => {
    const { pdm } = this.state;
    const { dispatch } = this.props;
    pdm.splice(index, 1);
    this.setState({ pdm });
    dispatch(addLog("Remove PDM Record client"));
  };
  getCurrency() {
    const { selectedOption } = this.state;
    const value = Currency.find(
      (note) => note.id === Number(selectedOption.value)
    );
    this.setState({ currency: value.name });
  }

  render() {
    let {
      currencies,
      pdm,
      componentErrorMessages,
      filteredFlightNumbers,
      selectedOption,
      DepartureAirportId,
      DestinationAirportId,
    } = this.state;
    const { airlines, departureAirports, destinationAirports } = this.props;
    return (
      <div>
        <Form ref={this.form} onSubmit={(e) => e.preventDefault()}>
          <Container>
            <div>
              <h6 className="mb-4 pull-left text-uppercase">
                Data Entry Panels
              </h6>
              <div className={"pull-right"}>
                <Button
                  className="btn-avi-secondary btn-block"
                  disabled={!pdm.length}
                  onClick={this.initializeSave}
                >
                  <AddIcon color="#ffffff" size="20" />
                  &nbsp;Save Record
                </Button>
              </div>
              <div className="clearfix"></div>
            </div>
            <Row>
              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="Airline">Airline</Label>
                  <SelectListComponent
                    placeholder={"Select Airline..."}
                    data={airlines}
                    valueKey="Id"
                    textField="Name"
                    selectValue={this.state.searchAirlineId}
                    onValueChange={(payload) =>
                      this.handleAirlineChange(payload)
                    }
                  />
                  {componentErrorMessages.searchAirlineId && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.searchAirlineId}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="FlightNumber">Flight Number</Label>
                  <SelectCreatableListComponent
                    data={filteredFlightNumbers}
                    placeholder={"Type Flight Number"}
                    valueKey="FlightNumber"
                    textField="FlightNumber"
                    selectValue={this.state.searchFlightNumber}
                    onValueChange={(payload) =>
                      this.handleFlightChange(payload)
                    }
                  />
                  {componentErrorMessages.searchFlightNumber && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.searchFlightNumber}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup
                  className={
                    "mb-4 " +
                    (this.state.componentErrorMessages.DepartureAirportId
                      ? "has-danger"
                      : "")
                  }
                >
                  <Label for="DepartureAirportId">Departure Airport</Label>
                  <SelectListComponent
                    data={departureAirports}
                    valueKey="Id"
                    textField="Name"
                    selectValue={DepartureAirportId}
                    onValueChange={(payload) =>
                      this.handleSelectChange(
                        payload,
                        "Id",
                        "DepartureAirportId"
                      )
                    }
                  />
                  {componentErrorMessages.DepartureAirportId && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.DepartureAirportId}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup
                  className={
                    "mb-4 " +
                    (this.state.componentErrorMessages.DestinationAirportId
                      ? "has-danger"
                      : "")
                  }
                >
                  <Label for="DestinationAirportId">Destination Airport</Label>
                  <SelectListComponent
                    data={destinationAirports}
                    valueKey="Id"
                    textField="Name"
                    selectValue={DestinationAirportId}
                    onValueChange={(payload) =>
                      this.handleSelectChange(
                        payload,
                        "Id",
                        "DestinationAirportId"
                      )
                    }
                  />
                  {componentErrorMessages.DestinationAirportId && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.DestinationAirportId}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="FlightDate">Flight Date</Label>
                  <DateSelector
                    maxDate={new Date()}
                    todayDate={new Date().toString()}
                    name="startDate"
                    onValueChange={(DepartureDate) =>
                      this.setState({ DepartureDate })
                    }
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-4">
                  <Label for="PAXCount">PAX Count</Label>
                  <Input
                    type="number"
                    name="select"
                    value={this.state.PAXCount}
                    onChange={this.paxChange.bind(this)}
                    ref={(input) => (this.PAXCOUNT = input)}
                  />
                  {componentErrorMessages.PAXCount && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.PAXCount}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-1">
                  <Label>TSC Amount</Label>
                  <Input
                    type="number"
                    value={this.state.TSCAmount}
                    name="select"
                    onChange={this.tscAmountChange.bind(this)}
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className={"mb-1"}>
                  <Label for="Currency"> Currency</Label>
                  <Select
                    name="form-field-name"
                    value={selectedOption}
                    onChange={this.handleCurrencyChange}
                    options={currencies}
                  />
                  {componentErrorMessages.Currency && (
                    <FormText color="danger">
                      {" "}
                      {componentErrorMessages.Currency}
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs="6" sm="2">
                <label>&nbsp;</label>
                <Button
                  className="btn-avi-primary btn-block"
                  onClick={this.handleSubmit.bind(this)}
                >
                  {" "}
                  Add Record
                </Button>
                <br />
              </Col>
            </Row>

            <PDMDataEntryRecord
              removeRecord={this.removeDataRecord}
              findCurrency={this.findCurrency}
              findAirline={this.findAirline}
              findAirport={this.findAirport}
              records={pdm}
            />
          </Container>
          <NotificationSystem ref="notificationSystem" />
          <Modal
            size={"lg"}
            isOpen={this.state.openModal}
            toggle={this.toggleModal}
            className={this.state.modalClass}
          >
            <ModalHeader toggle={this.toggleModal}>
              Confirm PDM Entry
            </ModalHeader>
            <ModalBody>
              <div className="text-center">
                <CheckIcon size="50" />
              </div>
              <h5 className="text-center mb-3">
                Are you sure you want to create PDM records?
              </h5>
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn-avi-primary"
                onClick={(e) => this.handleSave()}
              >
                {" "}
                Proceed{" "}
              </Button>
              <Button color="secondary" onClick={(e) => this.toggleModal()}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </Form>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    requesting: state.api.requesting,
    pageRequesting: state.api.pageRequesting,
    modal: state.modal,
    user: state.authentication.user,
  };
}

export default connect(mapStateToProps)(SearchPanel);



// WEBPACK FOOTER //
// ./src/views/pdm-data-entry/pdm-data-panel.js